const FeaturedTopicsTabs: React.FC = () => {
  return (
    <div className="featured-articles-container">
      <p>
        <a href="/" className="breadcrumb-link">
          Help Desk
        </a>{" "}
        &#10132;{" "}
        <a href="/featured-topics" className="breadcrumb-link">
          Featured Topics
        </a>{" "}
        &#10132; Tabs on the home page
      </p>
      <h2 className="help-heading">Tabs on the home page</h2>
      <img
        src={require("../../../assets/tabs-article-header.jpg")}
        alt="tabs-article-img"
        className="tabs-article-img"
      />
      <p className="featured-article-text">
        The home page of CEO.CA has many tabs that provide access to different aspects of the site. These tabs are:
      </p>
      <ol>
        <li><b>Home Button:</b> Returns you to the homepage.</li>
        <li><b>Watchlist:</b> Allows you to view, create, and edit your personalized stock watchlists.</li>
        <li><b>Companies:</b> Provides an overview of trending companies across Canadian exchanges, including the biggest gainers and losers. You can also see companies with unusual trading volume, news or trading halts, and filter results by market capitalization.</li>
        <li><b>Community:</b> Shows the most popular users and tagged topics on CEO.CA.</li>
        <li><b>News:</b> Gathers news releases related to CEO.CA and those companies on your watchlist.</li>
        <li><b>Research:</b> Our new <a href="https://new.ceo.ca/research">SEDAR Research Dashboard</a> simplifies access to public issuer filings with full-text searchability of millions of filings, news releases and financial statements.</li>
        <li><b>Insiders:</b> Our new <a href="https://new.ceo.ca/insiders">SEDI Dashboard</a> allows easy access to all available SEDI documents, with convenient filtering options.</li>
        <li><b>Videos:</b>Brings you to our YouTube channel featuring podcasts, interviews, short films, and more.</li>
        <li><b>Shop:</b> A shopping portal where you can purchase CEO.CA merchandise.</li>
      </ol>
    </div>
  );
};

export default FeaturedTopicsTabs;
